import type { ItemType } from 'antd/es/breadcrumb/Breadcrumb';
import { ArrowLeftOutlined, HomeOutlined } from '@ant-design/icons';
import { Link, type LinkProps } from '@tanstack/react-router';
import { Breadcrumb, Button } from 'antd';

const home = {
    title: (
        <Link className='flex items-center whitespace-nowrap text-inherit' to='/a/painel-gerencial'>
            <HomeOutlined style={{ paddingRight: 5 }} />
            Início
        </Link>
    ),
};

export function LayoutBreadcrumbs({ path, voltar }: { path: string[]; voltar?: LinkProps }) {
    const items: ItemType[] = [home];

    for (const title of path) {
        items.push({
            title: (
                <span className='block truncate' title={title}>
                    {title}
                </span>
            ),
        });
    }

    return (
        <div className='flex min-w-0 items-center gap-2 overflow-hidden py-1'>
            {voltar && (
                <Link className='shrink-0' {...voltar}>
                    <Button icon={<ArrowLeftOutlined />} size='small'>
                        Voltar
                    </Button>
                </Link>
            )}

            <Breadcrumb
                className='min-w-0 flex-1 overflow-hidden whitespace-nowrap [&_.ant-breadcrumb-link]:block [&_.ant-breadcrumb-link]:min-w-0 [&_.ant-breadcrumb-link]:truncate [&_.ant-breadcrumb-separator]:shrink-0 [&_li:first-child]:shrink-0 [&_li]:flex [&_li]:min-w-0 [&_li]:shrink [&_li]:items-center [&_ol]:min-w-0 [&_ol]:flex-nowrap [&_ol]:overflow-hidden'
                items={items}
                separator='>'
            />
        </div>
    );
}
